
import { Environment } from '@serviceos-ng/core';

// eslint-disable-next-line @nx/enforce-module-boundaries
import PackageJson from '../../../../package.json';

export const environment: Environment = {
  production: true,
  type: 'production',
  project: 'accounts',
  cookieKey: 'LMrofhHejiTWJeRYuVI6wV4cPmcb7H7u1nQg1M3UW8g',
  version: PackageJson.version + '.' + PackageJson.build,
  googleApiKey: 'AIzaSyCNN907cEUcIScGXC6w45IeNix1IYw711o',
  // iterableApiKey: '21140def45884681b148dbbfe8c4dfbf',
  iterableApiKey: 'ba19ddcfdc514924bf368db042c2fea3',
  deployURL: 'accounts',
  reporting: {
    getIpFile: 'get-ip.php',
    email: {
      enabled: true,
      url: 'https://web.serviceos.app/reports/'
    },
    sentry: {
      enabled: true, 
      dsn: 'https://b29b667c00d544aca8770c54460966be@sentry.serviceos.app/3',
    }
  }
};